module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetMedium@2x.8efb7a5.jpg";